import * as React from 'react'
import Breadcrumbs from '../Breadcrumbs.component'
import {sign} from 'jsonwebtoken';

const { METABASE_SITE_URL = '', METABASE_SECRET_KEY = '' } = process.env

class DashboardPage extends React.PureComponent {
  render() {    

    if (!METABASE_SECRET_KEY.length || !METABASE_SITE_URL.length) {
      return (<div>Metabase not configured...</div>)
    }

    const payload = {
      resource: { dashboard: 2 },
      params: {
        // location_code: ""        
      }
    };
    const token = sign(payload, METABASE_SECRET_KEY);
    const iframeUrl = METABASE_SITE_URL + "/embed/dashboard/" + token + "#bordered=false&titled=false";

    return (
      <div>
        <Breadcrumbs breadcrumbs={[{ name: 'Dashboard', active: true }]} />
        <iframe
          src={iframeUrl}
          frameBorder={0}
          width={'100%'}
          height={1000}
          // allowTransparency
      />
      </div>
    )
  }
}

export default DashboardPage



// WEBPACK FOOTER //
// ./src/routes/dashboard/Dashboard.page.tsx